import { Box } from '@optiaxiom/react';
import { createColumnHelper } from '@tanstack/react-table';

import { AgentExecutionItem } from '@frontend/types/agentExecution';

import {
  AgentNameCell,
  StatusCell,
  TimestampCell,
  TriggerNameCell,
  TriggerTypeCell,
} from './cells';

const columnHelper = createColumnHelper<AgentExecutionItem>();

type TableMeta = {
  onRowClick?: (execution: AgentExecutionItem) => void;
};

const createColumns = () => [
  columnHelper.accessor('start_time', {
    id: 'timestamp',
    header: 'Timestamp',
    cell: ({ row, table }) => {
      const meta = table.options.meta as TableMeta;
      const status = row.original.status.toLowerCase();
      return (
        <Box
          onClick={() => meta?.onRowClick?.(row.original)}
          cursor="pointer"
          w="full"
          data-status={status}
        >
          <TimestampCell timestamp={row.original.start_time} />
        </Box>
      );
    },
  }),
  columnHelper.display({
    id: 'trigger_type',
    header: 'Trigger Type',
    cell: ({ row, table }) => {
      const meta = table.options.meta as TableMeta;
      return (
        <Box onClick={() => meta?.onRowClick?.(row.original)} cursor="pointer" w="full">
          <TriggerTypeCell execution={row.original} />
        </Box>
      );
    },
  }),
  columnHelper.display({
    id: 'trigger_name',
    header: 'Trigger Name',
    cell: ({ row, table }) => {
      const meta = table.options.meta as TableMeta;
      return (
        <Box onClick={() => meta?.onRowClick?.(row.original)} cursor="pointer" w="full">
          <TriggerNameCell execution={row.original} />
        </Box>
      );
    },
  }),
  columnHelper.display({
    id: 'agent_name',
    header: 'Agent Name',
    cell: ({ row, table }) => {
      const meta = table.options.meta as TableMeta;
      return (
        <Box onClick={() => meta?.onRowClick?.(row.original)} cursor="pointer" w="full">
          <AgentNameCell execution={row.original} />
        </Box>
      );
    },
  }),
  columnHelper.accessor('status', {
    id: 'status',
    header: 'Status',
    cell: ({ row, table }) => {
      const meta = table.options.meta as TableMeta;
      return (
        <Box onClick={() => meta?.onRowClick?.(row.original)} cursor="pointer" w="full">
          <StatusCell status={row.original.status} />
        </Box>
      );
    },
  }),
];

export default createColumns;
